module.exports = __webpack_public_path__ + "static/media/ic_appt_unstash.8e9245b4.svg";